






















































import { QueryParams } from "@/models/general";
import User from "@/models/user";
import UsersAPI from "@/services/users";
import { LayoutModule } from "@/store/layout";
import { ReportModule } from "@/store/report";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SellersCampaignsFilter extends Vue {
  selectedUsers: string[] = [];
  users: User[] = [];
  selectAll = false;

  get getUserForFilter(): User[] {
    const users: User[] = [];
    this.selectedUsers.forEach((i) => {
      const u = this.users.find((u) => u.id === i);
      u ? users.push(u) : null;
    });

    return users;
  }

  created(): void {
    if (ReportModule.userFilter.length > 0)
      this.selectedUsers = ReportModule.userFilter.map((u) => u.id);
    this.getUsers();
  }

  validate(): void {
    const validForm = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();

    if (validForm) {
      this.applyFilter();
    }
  }

  async getUsers(): Promise<void> {
    const params: QueryParams = {
      page: {
        size: -1,
      },
    };

    const r = await UsersAPI.getUsers(params);

    this.users = r.data.sort((a, b) => {
      return a.name.localeCompare(b.name, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    });
  }

  applyFilter(): void {
    ReportModule.setUserFilter(this.getUserForFilter);
    LayoutModule.hideRightDrawer();
  }

  cancel(): void {
    LayoutModule.hideRightDrawer();
  }

  toggleAll(): void {
    // if(this.user)
    if (!this.selectAll) {
      this.users.forEach((u) => this.selectedUsers.push(u.id));
    } else {
      this.selectedUsers = [];
    }

    this.selectAll = !this.selectAll;
  }
}
